import { render, staticRenderFns } from "./checkbox-single-check.component.vue?vue&type=template&id=97f53e26&"
import script from "./checkbox-single-check.component.ts?vue&type=script&lang=ts&"
export * from "./checkbox-single-check.component.ts?vue&type=script&lang=ts&"
import style0 from "./checkbox-single-check.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports